"use strict";

exports.__esModule = true;
exports.getHeight = exports.PLANT_NAME_HEADER_SIZE = exports.PLANT_LINK_FOOTER_SIZE = void 0;
var PLANT_NAME_HEADER_SIZE = exports.PLANT_NAME_HEADER_SIZE = 42;
var PLANT_LINK_FOOTER_SIZE = exports.PLANT_LINK_FOOTER_SIZE = 77;
var getHeight = exports.getHeight = function getHeight(height) {
  return height - 2 - PLANT_NAME_HEADER_SIZE - PLANT_LINK_FOOTER_SIZE;
};